module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": _vm.handleClose
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickSave
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校区选择"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择校区",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedCampus),
      callback: function($$v) {
        _vm.selectedCampus = $$v
      },
      expression: "selectedCampus"
    }
  }, _vm._l((_vm.campusDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickAddCampus
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.formData.campusList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "card-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteCampus(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n               共计" + _vm._s(_vm.formData.campusList.length) + "个校区\n            ")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-252a1da2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/LuFundCampusShield.vue
// module id = 971
// module chunks = 0